<script setup>
    import { ref, onMounted } from 'vue'
    import { useRouter } from 'vue-router'
    import { useUserStore } from '../../../user/stores/user'
    import { useCookies } from "vue3-cookies"
    import { usePageLoadingStore } from "../../../../stores/pageLoading";
    import {useSignupStore} from "../../../user/stores/signup";
    import signinService from "../../../user/services/signin/signinService"
    import {useSiteMenuStore} from "../../../../stores/sitemenu";
    import {useNavigationStore} from "../../../../stores/navigation";
    import { useAlertStore } from '../../../../stores/alertStore';
    const { $alert } = useAlertStore();
    const { cookies } = useCookies();
    const router = useRouter()
    const userStore = useUserStore()
    const signupStore = useSignupStore()
    const loadingStore = usePageLoadingStore()
    const siteMenuStore = useSiteMenuStore()
    const navigationStore = useNavigationStore()

    onMounted(()=>{
        signupStore.setSignupRequest({});
        if(localStorage.getItem("ERR409") !== undefined && localStorage.getItem("ERR409") !== null) {
            $alert(["다른 기기에서 로그인이 감지되어 로그아웃합니다.", "직접 로그인을 하지 않으셨다면 로그인 후 비밀번호를 변경해주세요."]);
            localStorage.removeItem("ERR409");
        }
    })

    const input = ref({
        userLoginId: '',
        password: '',
    });

    const inputError = ref({
        userLoginId: '',
        password: '',
    })

    const checkedSaveId = ref(true);

    const cookie_user_id = cookies.get("userId");
    // console.log(cookie_user_id);
    if(cookie_user_id) {
        input.value.userLoginId = cookie_user_id;
    }

    const _login = async () => {
        const { userLoginId, password } = input.value;
        let isInvalid = false;

        inputError.value.userLoginId = '';
        inputError.value.password = '';

        if(!userLoginId) {
            inputError.value.userLoginId = '아이디를 입력해주세요.';
            isInvalid = true;
        }
        if(!password) {
            inputError.value.password = '비밀번호를 입력해주세요.';
            isInvalid = true;
        }

        if(!isInvalid) {
            loadingStore.loading = true;
            signinService.signin({loginType: 'admin', userLoginId, password})
                .then( (res) => {
                    loadingStore.loading = false;
                    // console.log(res);
                    if(res.data.code.toLowerCase() === 'success') {
                        const result = res.data.result;
                        userStore.setUser({
                            userGb: result.userGb,
                            userCd: result.userCd,
                            userLoginId: result.userLoginId,
                            userName: result.userName,
                            token: result.token,
                            refreshToken: result.refreshToken,
                            accessMenu: result.accessMenu,
                        });
                        siteMenuStore.getSiteMenu();

                        // console.log(checkedSaveId.value);
                        if(checkedSaveId.value) {
                            cookies.set("userId", input.value.userLoginId);
                        } else {
                            cookies.remove("userId");
                        }

                        if(navigationStore.lastAccessPage) {
                            router.push(navigationStore.lastAccessPage);
                            navigationStore.lastAccessPage = '';
                        } else {
                            let menu = 'Home'; // 일반 사용자
                            let accessMenu = result.accessMenu;
                            if (result.userGb === 'PARTNER_ADMIN') {
                                menu = getRouterNameforPartAdmin(accessMenu);
                            } else {
                                menu = getRouterNameforAdmin(accessMenu);
                            }
                            router.push({name: menu});
                        }
                    } else {
                        $alert(["아이디가 존재하지 않거나 아이디 또는 비밀번호가 올바르지 않습니다."])
                    }
                }).catch( (err) =>  {
                    // console.log(err);
                    loadingStore.loading = false;
                    // $toast('error', '오류가 발생하였습니다.');
                    let message = ["아이디가 존재하지 않거나 아이디 또는 비밀번호가 올바르지 않습니다."]
                    if (err.response && err.response.data && err.response.data.msg) {
                        // 담당기관의 담당기간이 지났을 경우, alert 창
                        // -> 담당기간이 지났을 경우 백엔드에서 "운영기간이 만료되었습니다"를 보냄
                        if ( err.response.data.msg.indexOf('운영기간이 만료되었습니다') > -1 ) {
                            message = ["운영기간이 만료되었습니다.","운영관리가 필요하신 경우 협회로 문의 바랍니다."];
                        } else {
                            message = ["아이디가 존재하지 않거나 아이디 또는 비밀번호가 올바르지 않습니다."]
                        }
                    }
                    $alert(message);
            });
        }
    }

    // 메뉴 수정/메뉴 추가 시, 수정 필요 4-1 (1~7)
    const getRouterNameforAdmin = (accessMenu) => {
        let menu = 'MemberList'
        if ( accessMenu.indexOf('us') > -1 ) {
            menu = 'MemberList'
        } else if ( accessMenu.indexOf('co') > -1 ) {
            menu = 'CorporationList'
        } else if ( accessMenu.indexOf('lt') > -1 ) {
            menu = 'LectureList'
        } else if ( accessMenu.indexOf('cr') > -1 ) {
            menu = 'LectureCourseList'
        } else if ( accessMenu.indexOf('hr') > -1 ) {
            menu = 'UserMatchingList'
        } else if ( accessMenu.indexOf('jf') > -1 ) {
            menu = 'OjfList'
        } else if ( accessMenu.indexOf('mg') > -1 ) {
            menu = 'MailSMSHistory'
        } else if ( accessMenu.indexOf('cs') > -1 ) {
            menu = 'CSNotifyList'
        } else if ( accessMenu.indexOf('st') > -1 ) {
            menu = 'SiteMainBanner'
        } else if ( accessMenu.indexOf('am') > -1 ) {
            menu = 'ManagerList'
        } else if ( accessMenu.indexOf('pa') > -1 ) {
            menu = 'PartnerList'
        }
        return menu;
    }

    // 메뉴 수정/메뉴 추가 시, 수정 필요 4-2 (1~7)
    const getRouterNameforPartAdmin = (accessMenu) => {
      let menu = 'PartnerLectureList'
      if ( accessMenu.indexOf('lt') > -1 ) {
          menu = 'PartnerLectureList'
      } else if ( accessMenu.indexOf('cr') > -1 ) {
          menu = 'PartnerLectureCourseList'
      }
      return menu;
    }

    const goView = (routeName) => {
        router.push({name: routeName});
    }

    const onKeyDown = (e)  => {
        if(e.keyCode === 13) { // enter
            console.log("enter");
            _login();
        }
    }
</script>

<template>
    <div class="sign-wrap" @keydown="onKeyDown" >
        <div class="sign-inner">
            <div class="title">
                <h3>관리자 로그인</h3>
            </div>
            <div class="sign-content">
                <KSAInput class="text-box" v-model="input.userLoginId" label="아이디" placeholder="아이디 입력하세요." max-length="20" :msg="inputError.userLoginId"/>
                <KSAInput type="password" class="text-box" v-model="input.password" label="비밀번호" placeholder="비밀번호 입력하세요." max-length="30" :msg="inputError.password"/>
                <p class="save"><KSACheckBox label="아이디 저장" v-model="checkedSaveId"/></p>
                <KSAPrimaryButton class="full-btn" text="로그인" @click="_login" />
            </div>
            <ul class="member">
                <li><span @click="goView('SigninSearchID')">아이디 찾기</span></li>
                <li><span @click="goView('SigninSearchPW')">비밀번호 찾기</span></li>
<!--                <li><span @click="goView('Signup')">회원가입</span></li>-->
            </ul>
        </div>
    </div>
</template>

<style scoped>

</style>